module.exports = __webpack_public_path__ + "img/lang-select.6ed698e7.svg";